// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2trHW","icon":"SortAdornment_icon__cCmWj","up":"SortAdornment_up__3LgHq","down":"SortAdornment_down__iiwbK","active":"SortAdornment_active__1VKi4"};